import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatSliderModule } from '@angular/material/slider';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { AdminRoutingModule } from './admin-routing.module';
import { HeaderModule } from '@app/header/header.module';
import { LayoutComponent } from '@admin/layout.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AddLocationComponent } from '@admin/pages/locations/add-location/add-location.component';
import { EditLocationComponent } from '@admin/pages/locations/edit-location/edit-location.component';
import { LocationsComponent } from '@admin/pages/locations/locations.component';
import { AddProjectComponent } from '@admin/pages/projects/add-project/add-project.component';
import { EditProjectComponent } from '@admin/pages/projects/edit-project/edit-project.component';
import { ProjectsComponent } from '@admin/pages/projects/projects.component';
import { AddUserComponent } from '@admin/pages/users/add-user/add-user.component';
import { EditUserComponent } from '@admin/pages/users/edit-user/edit-user.component';
import { UsersComponent } from '@admin/pages/users/users.component';
import { ReleaseNotesComponent } from '@admin/pages/release-notes/release-notes.component';
import { AddReleaseNoteComponent } from '@admin/pages/release-notes/add-release-notes/add-release-note.component';
import { EditReleaseNoteComponent } from '@admin/pages/release-notes/edit-release-notes/edit-release-note.component';
import { AddWorkCenterComponent } from '@admin/pages/locations/edit-location/work-centers/add-work-center/add-work-center.component';
import { EditWorkCenterComponent } from '@admin/pages/locations/edit-location/work-centers/edit-work-center/edit-workcenter.component';
import { WorkCentersComponent } from '@admin/pages/locations/edit-location/work-centers/work-centers.component';
import { CustomerSitesComponent } from '@admin/pages/customer-sites/customer-sites.component';
import { AddCustomerSiteComponent } from '@admin/pages/customer-sites/add-customer-site/add-customer-site.component';
import { EditCustomerSiteComponent } from '@admin/pages/customer-sites/edit-customer-site/edit-customer-site.component';
import { StatisticsComponent } from '@admin/pages/statistics/statistics.component';
import { WeightChangeCategoriesComponent } from '@admin/pages/weight-change-categories/weight-change-categories.component';

@NgModule({
  declarations: [
    AddLocationComponent,
    EditLocationComponent,
    LocationsComponent,
    AddProjectComponent,
    EditProjectComponent,
    AddWorkCenterComponent,
    EditWorkCenterComponent,
    WorkCentersComponent,
    CustomerSitesComponent,
    AddCustomerSiteComponent,
    EditCustomerSiteComponent,
    ProjectsComponent,
    AddUserComponent,
    EditUserComponent,
    UsersComponent,
    ReleaseNotesComponent,
    AddReleaseNoteComponent,
    EditReleaseNoteComponent,
    LayoutComponent,
    StatisticsComponent,
    WeightChangeCategoriesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // material modules
    MatExpansionModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatCardModule,
    MatGridListModule,
    MatOptionModule,
    MatSelectModule,
    MatInputModule,
    MatChipsModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatToolbarModule,
    MatSnackBarModule,
    MatFormFieldModule,
    // dwo modules
    AdminRoutingModule,
    HeaderModule,
  ],
})
export class AdminModule {}
